module.exports = __webpack_public_path__ + "img/51ne.9ff4a24f.svg";